import { FootprintPolygonsType, PositionType } from 'data/types';

export function calculateFootprintArea(
  points: PositionType[] | null | undefined
): number {
  if (!points || points.length < 3) return 0;
  let area = 0;
  for (let i = 0, j = points.length - 1; i < points.length; j = i, i += 1) {
    area += points[j].x * points[i].y - points[i].x * points[j].y;
  }
  return Math.round(Math.abs(area) / 2);
}

export function scaleFootprintPoints(
  points: PositionType[],
  ratio: number,
  center: PositionType
): PositionType[] {
  return points.map((p) => ({
    x: center.x + (p.x - center.x) * ratio,
    y: center.y + (p.y - center.y) * ratio
  }));
}

export function transformFootprintPolygons(
  polygons: FootprintPolygonsType,
  transform: { ratio: number; dx: number; dy: number; center: PositionType }
): FootprintPolygonsType {
  const { ratio, dx, dy, center } = transform;
  return polygons.map((polygon) =>
    scaleFootprintPoints(polygon, ratio, center).map((p) => ({
      ...p,
      x: p.x + dx,
      y: p.y + dy
    }))
  );
}

export function calculateAutoScaleRatio(
  currentArea: number,
  targetArea: number
): number {
  if (currentArea <= 0 || targetArea <= 0) return 1;
  return Math.sqrt(targetArea / currentArea);
}

export function getScaledFootprintArea(
  area: number,
  scaleRatio: number
): number {
  if (area <= 0) return 0;
  if (scaleRatio === 1) return area;
  return Math.round(area * scaleRatio * scaleRatio);
}
